// Libs
import _find from 'lodash/find'

// utils
import {
  getHeftyCropConversionFactor,
} from 'hfty-utils'

// Constants
import {
  PROP_YIELD_TARGET,
  PROP_DATA,
  PROP_YIELD_GOAL,
  PROP_CROP,
} from 'hfty-model-comments'

import {
  PROP_REMOVAL_YIELD,
  PROP_REMOVAL_CROP,
} from 'hfty-model-recommendations'

import {
  PROP_CROP_ID,
} from 'fc-model-crops'

export function convertCommentsToFrontendUnits (model, crops, unitSystem) {
  const crop = _find(crops, (crop) => (
    crop[PROP_CROP_ID] === model[PROP_CROP])
  ) || {}

  const conversionFactorCrop = getHeftyCropConversionFactor(crop, unitSystem)

  return {
    ...model,
    [PROP_YIELD_TARGET]: (model[PROP_YIELD_TARGET] != null && model[PROP_YIELD_TARGET] !== ''
      ? Number(model[PROP_YIELD_TARGET]) * conversionFactorCrop : null),
    [PROP_DATA]: {
      ...model[PROP_DATA],
      [PROP_YIELD_GOAL]: (model[PROP_DATA] != null && model[PROP_DATA][PROP_YIELD_GOAL] != null &&
        model[PROP_DATA][PROP_YIELD_GOAL] !== ''
        ? Number(model[PROP_DATA][PROP_YIELD_GOAL]) * conversionFactorCrop : null),
    },
  }
}

export function convertCommentsToBackendUnits (model, crops, unitSystem) {
  const crop = _find(crops, (crop) => (
    crop[PROP_CROP_ID] === model[PROP_CROP])
  ) || {}

  const cropRemoval = _find(crops, (crop) => (
    crop[PROP_CROP_ID] === model[PROP_REMOVAL_CROP])
  ) || {}

  const conversionFactorCrop = getHeftyCropConversionFactor(crop, unitSystem)
  const conversionFactorRemovalCrop = getHeftyCropConversionFactor(cropRemoval, unitSystem)

  return {
    ...model,
    [PROP_YIELD_TARGET]: (model[PROP_YIELD_TARGET] != null && model[PROP_YIELD_TARGET] !== ''
      ? Number(model[PROP_YIELD_TARGET]) / conversionFactorCrop : null),
    [PROP_REMOVAL_YIELD]: (model[PROP_REMOVAL_YIELD] != null && model[PROP_REMOVAL_YIELD] !== ''
      ? Number(model[PROP_REMOVAL_YIELD]) / conversionFactorRemovalCrop : null),
  }
}
